import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {IndexConfigService} from './index.config.service';
import {Load} from '../_decorators/loading.decorator';
import {LoginHelper} from '../helpers';
import {InspectionProfile} from "../_models/inspectionProfile";
import {FixDates} from "../_decorators/date.decorator";
import { Device } from '../_models/device';
import {InspectionResultsPopupComponent} from "../components/inspectionResultsPopup/inspectionResultsPopup.component";

@Injectable()
export class InspectionProfileService {
  constructor(
    public http: HttpClient,
    public authenticationService: AuthenticationService,
    public config: IndexConfigService
  ) {
  }

  @Load()
  saveInspectionProfileSet(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/inspectionProfileSets', result);
  }
  @Load()
  deleteInspectionProfileSet(id: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete<any>(this.config.api + '/api/inspectionProfileSets/' + id);
  }
  @FixDates()
  getAllInspectionProfileSets() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/inspectionProfileSets');
  }
  @Load()
  getAll(): Observable<InspectionProfile[]> {
    if (!this.canExecute()) {
      return null;
    }

    return this.http
      .get<InspectionProfile[]>(this.config.api + '/api/InspectionProfile')
      .pipe(
        map((response) => {
          return response.map(this.mapInspectionProfile);
        })
      );
  }

  @Load()
  getById(id: number): Observable<InspectionProfile> {
    if (!this.canExecute()) {
      return null;
    }

    return this.http
      .get<InspectionProfile>(this.config.api + `/api/InspectionProfile/${id}`)
      .pipe(map(this.mapInspectionProfile));
  }

  @Load()
  add(inspectionProfile: InspectionProfile): Observable<InspectionProfile> {
    if (!this.canExecute()) {
      return null;
    }

    return this.http
      .post<InspectionProfile>(this.config.api + `/api/InspectionProfile`, inspectionProfile)
      .pipe(map(this.mapInspectionProfile));
  }

  @Load()
  update(inspectionProfile: InspectionProfile | any) {
    if (!this.canExecute()) {
      return null;
    }

    return this.http.patch<InspectionProfile>(
      this.config.api + `/api/InspectionProfile/${inspectionProfile.id}`,
      inspectionProfile
    );
  }

  @Load()
  download(inspectionProfile: InspectionProfile) {
    if (!this.canExecute()) {
      return null;
    }

    return this.http.get(
      this.config.api + `/api/InspectionProfile/download/${inspectionProfile.id}`,
      {
        responseType: 'arraybuffer',
        headers: {}
      }
    );
  }

  @Load()
  delete(id: number) {
    if (!this.canExecute()) {
      return null;
    }

    return this.http.delete(this.config.api + `/api/InspectionProfile/${id}`);
  }

  @Load()
  test(inspectionProfile: InspectionProfile) {
    return this.http.post(
      this.config.api + `/api/InspectionProfile/${inspectionProfile.id}/test`,
      inspectionProfile
    );
  }

  @Load()
  getFindingsForItProfile(itProfileId: number): Observable<Device[]> {
    return this.http.get<Device[]>(
      this.config.api + `/api/inspectionProfileResults/itProfile/${itProfileId}`);
  }

  @Load()
  parseExample(file: File){
    if (!this.canExecute()) {
      return null;
    }

    let formData = new FormData();

    formData.append(file.name, file);

    return this.http
      .post<any>(this.config.api + '/api/InspectionProfile/parseExample', formData);
  }

  private canExecute() {
    if (
      LoginHelper.getTenantName() == null ||
      LoginHelper.getUserToken() == null
    ) {
      this.authenticationService.logout();

      return false;
    }

    return true;
  }

  private mapInspectionProfile(inspectionProfile: InspectionProfile) {
    let data = {...inspectionProfile};
    return data;
  }
}
